import { FunctionComponent } from 'react';
import Button from '../../../../Button';
import styles from './styles.module.scss';

type OccurrenceButtonProps = {
    isBookable: boolean;
    isSoldOut: boolean;
    isWaitlistEnabled: boolean;
    isBlock: boolean;
    isApplication: boolean;
    hasBookableChildOccurrences?: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const OccurrenceButton: FunctionComponent<OccurrenceButtonProps> = ({
    isBookable,
    isSoldOut,
    isWaitlistEnabled,
    isBlock,
    isApplication,
    hasBookableChildOccurrences,
    onClick,
}) => {
    if (isBookable === false) {
        return null;
    }

    if (isSoldOut && isWaitlistEnabled) {
        return (
            <Button preset="warning" onClick={onClick} className={styles.btn}>
                Join Waitlist
            </Button>
        );
    }

    if (isSoldOut) {
        return (
            <Button disabled aria-disabled className={styles.btn}>
                Sold Out
            </Button>
        );
    }

    if (isApplication) {
        return (
            <Button preset="primary" onClick={onClick} className={styles.btn}>
                Apply
            </Button>
        );
    }

    if (isBlock && hasBookableChildOccurrences) {
        return (
            <Button preset="primary" onClick={onClick} className={styles.btn}>
                Book All
            </Button>
        );
    }

    return (
        <Button preset="primary" className={styles.btn} onClick={onClick}>
            Book
        </Button>
    );
};
